import { ReactNode } from 'react';

export const BgImageContainer = ({ children }: { children: ReactNode }) => (
  <div className='min-h-screen bg-[url("/assets/svgs/booking/payment.svg")] bg-[length:700px_100%] bg-[0px] bg-no-repeat min-[700px]:bg-none'>
    {children}
  </div>
);
